import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
  },
  methods: {
    getLabelClass() {
      if (!this.campaign.state) {
        return 'label-gray';
      }

      switch (this.campaign.state) {
        case 'DORMANT':
          return 'label-blue';
        case 'DRAFT':
          return 'label-gray';
        case 'ENDED':
          return 'label-dark';
        case 'LIVE':
          return 'label-success';
        case 'REVIEW':
          return 'label-warning';
        case 'PAUSED':
          return 'label-danger';
        default:
          return 'label-gray';
      }
    },
    getPageTitleAttributes() {
      if (this.campaign.name && this.campaign.state) {
        return { name: this.campaign.name, state: this.campaign.state };
      }
      return { name: `New Campaign - ${this.title}`, state: 'DRAFT' };
    },
  },
};
